import { ALCOHOL_DISCLAIMER } from '@nandosaus/constants';

import { Col, Container, Row } from '../grid';
import { P } from '../typography/new';
import { useFeature } from '../../hooks/use-feature';

const MenuDisclaimer = () => {
  const alcoholPurchaseEnabled = useFeature('purchase-alcohol');

  if (!alcoholPurchaseEnabled) {
    return null;
  }

  return (
    <Container>
      <Row width="100%" justifyContent="center">
        <Col maxWidth="793px" width="100%">
          <P variant="standard" textAlign="center" color="grey70">
            {ALCOHOL_DISCLAIMER}
          </P>
        </Col>
      </Row>
    </Container>
  );
};

export { MenuDisclaimer };
